import { formatDateWithFormatter, uniqBy } from '@/utils/function'
import { useTranslation } from 'react-i18next'
import { CollapsedJourneyCardProps } from './types'

const CollapsedJourneyCard = ({
    journey,
    journeyIndex,
    isUpsell,
    outcome,
    onExpand,
}: CollapsedJourneyCardProps) => {
    const { t } = useTranslation()

    return (
        <div
            className="bg-gray-50 rounded-md border border-gray-200 px-4 py-2.5 flex items-center justify-between cursor-pointer hover:bg-gray-100 transition-colors"
            onClick={onExpand}
        >
            <div className="flex items-center gap-3">
                <svg
                    className="w-4 h-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                    />
                </svg>
                <span className="text-sm font-medium text-gray-500">
                    #{journeyIndex + 1}
                </span>
                <span className="text-xs font-medium">
                    {journey.customer_journey_explaination?.service_interestings
                        ?.slice(0, 3)
                        .join(', ') || t('untitled')}
                    {(journey.customer_journey_explaination
                        ?.service_interestings?.length ?? 0) > 3 && (
                        <>
                            {' '}
                            <span className="text-gray-300 ml-4">•</span>{' '}
                            <span className="text-gray-500">
                                +
                                {(journey.customer_journey_explaination
                                    ?.service_interestings?.length ?? 0) -
                                    3}{' '}
                                {t('sale-process.more')}
                            </span>
                        </>
                    )}
                </span>
                <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${
                        outcome === 'won'
                            ? 'bg-gray-200 text-gray-600'
                            : outcome === 'lost'
                              ? 'bg-gray-200 text-gray-600'
                              : 'bg-gray-200 text-gray-500'
                    }`}
                >
                    {outcome === 'won'
                        ? 'Won'
                        : outcome === 'lost'
                          ? 'On Hold'
                          : 'Ended'}
                </span>
                {isUpsell && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-gray-200 text-gray-500 font-medium">
                        Upsell
                    </span>
                )}
                {journey.employee_sale_followers &&
                    journey.employee_sale_followers.length > 0 && (
                        <span className="text-xs text-gray-400">
                            - Sales:{' '}
                            {uniqBy(
                                journey?.employee_sale_followers,
                                'employee_id'
                            )
                                ?.map((e) => e.employee_name)
                                .join(', ')}
                        </span>
                    )}
            </div>
            <span className="text-xs text-gray-400">
                {formatDateWithFormatter(
                    journey.customer_journey_created_at,
                    'DD/MM/YYYY'
                )}
            </span>
        </div>
    )
}

export default CollapsedJourneyCard
